import React, { useState } from "react"
import { withStyles } from "@material-ui/core/styles"
import { InputBase } from "@material-ui/core/"
import styles from "./styles"
import ActionBar from "../../../../components/ActionBar"
import PagesGrid from "../../../../components/PagesGrid"
import ConnectedOrganizations from "../../../../components/ConnectedOrganizations"
import GetConnected from "components/SideBox/components/GetConnected"
import SearchIcon from "@material-ui/icons/Search"

const Organizations = ({ classes }) => {
  const [searchFilter, setSearchFilter] = useState("")
  const handleSearch = e => {
    const searchValue = e.target.value
    setSearchFilter(searchValue)
  }

  return (
    <PagesGrid
      actionBar={
        <ActionBar
          searchBar={
            <div className={classes.searchBar}>
              <SearchIcon className={classes.searchIcon} />
              <InputBase
                placeholder="Search"
                className={classes.searchInput}
                onChange={e => handleSearch(e)}
              />
            </div>
          }
        />
      }
      content={<ConnectedOrganizations searchFilter={searchFilter} />}
      sideBox={<GetConnected />}
      noGrid
    />
  )
}

export default withStyles(styles)(Organizations)



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Organizations/index.jsx